module.exports = __webpack_public_path__ + "static/img/loading2.f80f7df.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading2.gif
// module id = aKXg
// module chunks = 1